"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableRowActions = exports.TableRowAction = exports.TableRow = exports.TableHeading = exports.TableCell = exports.Table = void 0;

var table_1 = require("./table");

Object.defineProperty(exports, "Table", {
  enumerable: true,
  get: function get() {
    return table_1.Table;
  }
});

var table_cell_1 = require("./partials/table-cell");

Object.defineProperty(exports, "TableCell", {
  enumerable: true,
  get: function get() {
    return table_cell_1.TableCell;
  }
});

var table_heading_1 = require("./partials/table-heading");

Object.defineProperty(exports, "TableHeading", {
  enumerable: true,
  get: function get() {
    return table_heading_1.TableHeading;
  }
});

var table_row_1 = require("./partials/table-row");

Object.defineProperty(exports, "TableRow", {
  enumerable: true,
  get: function get() {
    return table_row_1.TableRow;
  }
});

var table_row_action_1 = require("./partials/table-row-action");

Object.defineProperty(exports, "TableRowAction", {
  enumerable: true,
  get: function get() {
    return table_row_action_1.TableRowAction;
  }
});

var table_row_actions_1 = require("./partials/table-row-actions");

Object.defineProperty(exports, "TableRowActions", {
  enumerable: true,
  get: function get() {
    return table_row_actions_1.TableRowActions;
  }
});